export default __webpack_public_path__ + "static/media/regular.133ad199.woff2";